import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { Area, Category, UpdateAreaRequest } from '@ilteducation/content-ref-data-types';
import store from '@/store';
import { getAllRefData } from '@/data-provider/refDataProvider';

type Props = {
  category: Category;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AreaOrderEdit',
  props: {
    category: null
  },
  setup(__props: any) {

const props = __props as {
  category: Category;
}


const areasInCategory = ref<Area[]>([]);
const isLoading = ref(false);
const isFetching = ref(true);

const updateAreaOrder = () => {
  isLoading.value = true;
  const areasWithUpdatedOrder = areasInCategory.value.map((area, index) => ({ ...area, order: index + 1 }));

  try {
    areasWithUpdatedOrder.forEach(async (area) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { lastUpdatedAt, createdAt, ...newArea } = area; // including BaseRefData in update request results in validation error

      const areaUpdateRequest: UpdateAreaRequest = {
        ...newArea,
      };

      await store.dispatch('areas/update', {
        id: area.id,
        data: areaUpdateRequest,
      });
    });
  } finally {
    isLoading.value = false;
  }
};

getAllRefData('areas').then((areas: Area[]) => {
  areasInCategory.value = areas
    .filter((area) => area.categoryId === props.category.id)
    .sort((a, b) => (a.order || -1) - (b.order || -1));
  isFetching.value = false;
});

return { __sfc: true,props, areasInCategory, isLoading, isFetching, updateAreaOrder }
}

})